// 301 Redirects Mapping
// Add redirects here when URLs change to maintain SEO

export interface Redirect {
  from: string; // Old URL path (normalized, no trailing slash)
  to: string;   // New URL path
  type: 301 | 302;
}

export const redirects: Redirect[] = [
  // Consultation to Appointment redirects
  { from: "/consultation", to: "/appointment", type: 301 },
  { from: "/es/consulta", to: "/es/cita", type: 301 },
  { from: "/vi/tu-van", to: "/vi/cuoc-hen", type: 301 },
  // Canonical practice area root slugs
  { from: '/practice-areas/tax', to: '/practice-areas/tax-law', type: 301 },
  { from: '/practice-areas/real-estate', to: '/practice-areas/real-estate-law', type: 301 },
  { from: '/practice-areas/probate-estate-planning', to: '/practice-areas/probate-estate', type: 301 },

  // Immigration Services redirects
  { from: '/service/asylum-in-the-united-states', to: '/practice-areas/immigration-services/asylum-in-the-united-states', type: 301 },
  { from: '/service/family-based-immigration', to: '/practice-areas/immigration-services/family-based-immigration', type: 301 },
  { from: '/service/employment-based-immigration', to: '/practice-areas/immigration-services/employment-based-immigration', type: 301 },
  { from: '/service/deportation-removal-defense', to: '/practice-areas/immigration-services/deportation-removal-defense', type: 301 },
  { from: '/service/waivers-i601-i601a-i212', to: '/practice-areas/immigration-services/waivers-i601-i601a-i212', type: 301 },
  { from: '/service/deferred-action-for-childhood-arrivals-daca', to: '/practice-areas/immigration-services/deferred-action-for-childhood-arrivals', type: 301 },
  { from: '/service/u-s-citizenship-naturalization-make-america-your-forever-home', to: '/practice-areas/immigration-services/citizenship-naturalization', type: 301 },
  { from: '/service/u-visa', to: '/practice-areas/immigration-services/u-visa', type: 301 },
  { from: '/service/vawa-petitions', to: '/practice-areas/immigration-services/vawa-petitions', type: 301 },
  { from: '/service/consular-processing', to: '/practice-areas/immigration-services/consular-processing', type: 301 },
  { from: '/service/advance-parole', to: '/practice-areas/immigration-services/advance-parole', type: 301 },
  { from: '/service/re-entry-permit', to: '/practice-areas/immigration-services/re-entry-permit', type: 301 },
  { from: '/service/permanent-resident-card-renewal', to: '/practice-areas/immigration-services/green-card-renewal', type: 301 },
  { from: '/service/u-s-work-visas-legal-employment-opportunities-for-foreign-talent', to: '/practice-areas/immigration-services/employment-based-immigration', type: 301 },
  { from: '/service/u-s-student-visas-study-grow-and-succeed-in-america', to: '/practice-areas/immigration-services/student-visas', type: 301 },
  { from: '/service/k-1-fiance-visa', to: '/practice-areas/immigration-services/k-1-fiance-visa', type: 301 },
  { from: '/service/eb-5-immigrant-investor-visa', to: '/practice-areas/immigration-services/eb-5-investor-visa', type: 301 },
  
  // Criminal Defense redirects
  { from: '/service/dwi', to: '/practice-areas/criminal-defense/dwi', type: 301 },
  { from: '/service/drug-charges-defense', to: '/practice-areas/criminal-defense/drug-charges', type: 301 },
  { from: '/service/assault-family-violence-defense', to: '/practice-areas/criminal-defense/assault-family-violence', type: 301 },
  { from: '/service/houston-violent-crimes-defense-attorney', to: '/practice-areas/criminal-defense/violent-crimes', type: 301 },
  { from: '/service/theft-robbery-defense-attorney', to: '/practice-areas/criminal-defense/theft-robbery', type: 301 },
  { from: '/service/sex-crimes-defense-attorney', to: '/practice-areas/criminal-defense/sex-crimes', type: 301 },
  { from: '/service/expunction-nondisclosure', to: '/practice-areas/criminal-defense/expunction-nondisclosure', type: 301 },
  
  // Personal Injury redirects
  { from: '/service/auto-accident-injury-claims', to: '/practice-areas/personal-injury/auto-accident', type: 301 },
  { from: '/service/truck-accident-lawyer', to: '/practice-areas/personal-injury/truck-accident', type: 301 },
  { from: '/service/industrial-accident-lawyer', to: '/practice-areas/personal-injury/industrial-accident', type: 301 },
  { from: '/service/medical-injury-malpractice-claims', to: '/practice-areas/personal-injury/medical-malpractice', type: 301 },
  
  // Family Law redirects
  { from: '/service/divorce-representation', to: '/practice-areas/family-law/divorce', type: 301 },
  { from: '/service/child-custody-representation', to: '/practice-areas/family-law/child-custody', type: 301 },
  { from: '/service/child-support-enforcement', to: '/practice-areas/family-law/child-support', type: 301 },
  { from: '/service/cps-defense', to: '/practice-areas/family-law/cps-defense', type: 301 },
  { from: '/service/adoption-parental-termination-lawyer', to: '/practice-areas/family-law/adoption-parental-termination', type: 301 },
  { from: '/service/court-order-modification-lawyer', to: '/practice-areas/family-law/court-order-modification', type: 301 },
  
  // Tax redirects
  { from: '/service/tax-litigation', to: '/practice-areas/tax/tax-litigation', type: 301 },
  { from: '/service/personal-income-tax-filing', to: '/practice-areas/tax/tax-planning', type: 301 },
  { from: '/service/tax-audit', to: '/practice-areas/tax/tax-debt-resolution', type: 301 },
  
  // Probate & Estate redirects
  { from: '/service/probate-of-estate-with-will', to: '/practice-areas/probate-estate-planning/probate-administration', type: 301 },
  { from: '/service/probate-of-estate-without-a-will', to: '/practice-areas/probate-estate-planning/probate-administration', type: 301 },
  { from: '/service/estate-administration', to: '/practice-areas/probate-estate-planning/estate-planning', type: 301 },
  { from: '/service/living-trusts', to: '/practice-areas/probate-estate-planning/estate-planning', type: 301 },
  { from: '/service/irrevocable-trusts', to: '/practice-areas/probate-estate-planning/estate-planning', type: 301 },
  { from: '/service/durable-power-of-attorney', to: '/practice-areas/probate-estate-planning/estate-planning', type: 301 },
  { from: '/service/medical-power-of-attorney', to: '/practice-areas/probate-estate-planning/estate-planning', type: 301 },
  { from: '/service/special-needs-trust', to: '/practice-areas/probate-estate-planning/special-needs-trust', type: 301 },
  { from: '/service/guardianship', to: '/practice-areas/probate-estate-planning/guardianship', type: 301 },
  
  // Real Estate redirects
  { from: '/service/buying-and-selling-residential-property', to: '/practice-areas/real-estate/buying-selling-residential', type: 301 },
  { from: '/service/title-search', to: '/practice-areas/real-estate/title-search', type: 301 },
  { from: '/service/contract-review-avoid-surprises-and-legal-risks', to: '/practice-areas/real-estate/contract-review', type: 301 },
  { from: '/service/affidavit-of-heirship-prove-property-inheritance-without-probate', to: '/practice-areas/real-estate/affidavits-heirship', type: 301 },
  { from: '/service/affidavits-of-heirship', to: '/practice-areas/real-estate/affidavits-heirship', type: 301 },
  { from: '/service/lien-release-and-removal', to: '/practice-areas/real-estate/lien-release', type: 301 },
  { from: '/service/landlord-tenant-lease-negotiations-fair-agreements-clear-terms', to: '/practice-areas/real-estate/lease-negotiations', type: 301 },
  { from: '/service/residential-commercial-closings-smooth-secure-real', to: '/practice-areas/real-estate/closings', type: 301 },
  { from: '/service/foreclosures-evictions-protecting-your-rights-in-property-disputes', to: '/practice-areas/real-estate/foreclosures-evictions', type: 301 },
  
  // Business Law redirects
  { from: '/service/formation-of-business-entities', to: '/practice-areas/business-law/business-formation', type: 301 },
  { from: '/service/partnership-agreements', to: '/practice-areas/business-law/partnership-agreements', type: 301 },
  { from: '/service/trademark-registration', to: '/practice-areas/business-law/trademark-registration', type: 301 },
  { from: '/service/purchase-and-sale-of-business', to: '/practice-areas/business-law/purchase-sale-business', type: 301 },
  { from: '/service/registered-agent-services-stay-legally-compliant-in-texas', to: '/practice-areas/business-law/registered-agent', type: 301 },
  { from: '/service/debt-collection-recover-what-youre-owed-legally-and-effectively', to: '/practice-areas/business-law/debt-collection', type: 301 },
  { from: '/service/insurance-claim', to: '/practice-areas/business-law/insurance-claims', type: 301 },
  { from: '/service/formation-of-non-profit', to: '/practice-areas/business-law/nonprofit-formation', type: 301 },
  { from: '/service/closing-of-business-entities-end-your-business-the-right-way', to: '/practice-areas/business-law/business-closing', type: 301 },
];

/**
 * Check if a path needs redirection
 * @param pathname - Current pathname
 * @param search - Query string (optional, for preserving lang parameter)
 * @returns Redirect destination or null
 */
export function getRedirect(pathname: string, search?: string): string | null {
  const normalized = pathname.replace(/\/$/, '').toLowerCase();
  
  const redirect = redirects.find(r => 
    r.from.replace(/\/$/, '').toLowerCase() === normalized
  );
  
  if (!redirect) return null;
  
  // Preserve language parameter if present
  if (search) {
    const params = new URLSearchParams(search);
    const lang = params.get('lang');
    if (lang) {
      return `${redirect.to}?lang=${lang}`;
    }
  }
  
  return redirect.to;
}

/**
 * Validate no redirect chains exist
 */
export function validateRedirects(): Array<{
  from: string;
  issue: string;
}> {
  const issues: Array<{ from: string; issue: string }> = [];
  
  redirects.forEach(redirect => {
    // Check for circular redirects
    const chain = [redirect.from];
    let current = redirect.to;
    let depth = 0;
    
    while (depth < 10) {
      const next = getRedirect(current);
      if (!next) break;
      
      if (chain.includes(next)) {
        issues.push({
          from: redirect.from,
          issue: `Circular redirect detected: ${chain.join(' → ')} → ${next}`
        });
        break;
      }
      
      chain.push(next);
      current = next;
      depth++;
    }
    
    // Warn about chains longer than 1
    if (chain.length > 2) {
      issues.push({
        from: redirect.from,
        issue: `Redirect chain (${chain.length} hops): ${chain.join(' → ')}`
      });
    }
  });
  
  return issues;
}
